import React, { useState } from 'react';
import { usePage, router } from '@inertiajs/react';
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
import {useEnhancedTranslation} from "laravel-inertia-backend";
import HelpTooltip from "../../Components/HelpTooltip.jsx";

export default function TermOfPaymentMapping() {
    const {t, getLocales} = useEnhancedTranslation();
    const { shopPaymentMethods = [], weclappTerms = [], mappings = {} } = usePage().props;
  const [state, setState] = useState(() => {
    const init = {};
    shopPaymentMethods.forEach((m) => {
      init[m] = mappings[m] ?? '';
    });
    return init;
  });

  const handleChange = (shopMethod, value) => {
    setState((prev) => ({ ...prev, [shopMethod]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    router.post('/weclapp/term-of-payment-mapping', { mappings: state });
  };

  return (
    <Container className="mt-3">
        <h1 className="d-inline-flex align-items-center gap-2">
            {t('weclapp term of payment mapping')}
            <HelpTooltip placement="right" size={0.95}>
              <div className="text-start">
                <strong>Wozu dient diese Seite?</strong>
                <div className="mt-1">Hier ordnest du jede <strong>Shop-Zahlungsart</strong> einer <strong>Weclapp-Zahlungsbedingung</strong> zu.</div>
                <div className="mt-1">Diese Zuordnung wird beim Übertragen von Belegen nach Weclapp verwendet, um die passende Zahlungsbedingung zu setzen.</div>
              </div>
            </HelpTooltip>
        </h1>
      <Row className={"mb-5"}>
        <Col>
          <Card className="mb-4">
            <Card.Header as={"h5"} className={"card-header"}>
                Zahlungsbedingungen Zuordnung
            </Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                {shopPaymentMethods.length === 0 && (
                  <p>Keine Zahlungsarten im Shop gefunden.</p>
                )}
                  <Row className="mb-3">
                      <Col>
                          <h6>Weclapp Zahlungsbedingungen</h6>
                      </Col>
                      <Col>
                          <h6>Shop Zahlungsarten</h6>
                      </Col>
                  </Row>
                {shopPaymentMethods.map((shopMethod) => (
                  <Form.Group className="mb-3 row" controlId={`map-${shopMethod}`} key={shopMethod}>
                      <Col sm={6}>
                      <Form.Label>
                          {shopMethod}
                    </Form.Label>
                      </Col>
                      <Col sm={6}>
                    <Form.Select
                      value={state[shopMethod] ?? ''}
                      onChange={(e) => handleChange(shopMethod, e.target.value)}
                    >
                      <option value="">— Keine Zuordnung —</option>
                      {weclappTerms.map((term) => (
                        <option key={term} value={term}>
                          {term}
                        </option>
                      ))}
                    </Form.Select>
                      </Col>
                  </Form.Group>
                ))}

                <div className="d-flex justify-content-end">
                  <Button type="submit" variant="primary">
                    Speichern
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
